import classNames from 'classnames';
import CalendarCard from './CalendarCard';
import { IScheduleSlot } from '@/app/interfaces/schedule';
import { Fragment } from 'react';

interface ScheduleCalendarProps {
  rows: (IScheduleSlot | null)[][];
  className?: string;
}

export default function ScheduleCalendarGrid({
  rows,
  className
}: ScheduleCalendarProps) {
  return (
    <div
      className={classNames('grid lg:grid-cols-7 gap-1.5 xl:gap-1', className)}
    >
      {!rows.length && (
        <div className="p-3 bg-white rounded flex h-44 items-center justify-center gap-4 lg:col-span-7">
          <span className="text-p2">Занятий нет</span>
        </div>
      )}
      {!!rows.length &&
        rows.map((row, rowIndex) => (
          <Fragment key={rowIndex}>
            {row.map((item, index) => {
              if (!item) return <div key={index}></div>;

              return <CalendarCard key={index} {...item} />;
            })}
          </Fragment>
        ))}
    </div>
  );
}
